<template>
  <section v-scroll="onScroll" v-cloak> 

    <!-- <h1 style="position: fixed; bottom: 11px; left: 11px; z-index: 9999; background-color: #fff;border-radius: 6px;padding: 5px">{{offsetTop}}</h1> -->
    <h1 class="d-none d-lg-block" style="position: absolute; top: -40px; left: 50px; z-index: 1;font-size: 220px;font-family:'Baloo', sans-serif;color: #6e8bf1;">she</h1>

        <v-container :class="{'section-mobile': $vuetify.breakpoint.mdAndDown}" class="section-full mb-2 pb-1" id="global-economy" grid-list-xl style="position: relative;">

          <v-layout
            row
            wrap
            align-center
            :class="{'pt-0 justify-center': $vuetify.breakpoint.mdAndDown, 'pt-5, mt-5': $vuetify.breakpoint.lgAndUp}"
          >
          <v-flex class="hidden-md-and-down" v-for="i in 2" xs12 :key="i"></v-flex>
          <v-flex xs12 sm10 md6 lg4 offset-xs0 offset-lg1 :class="{'py-3': $vuetify.breakpoint.mdAndDown, 'py-5, my-5': $vuetify.breakpoint.lgAndUp}">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated fadeInDown fast"
              appear
            >
            
            </transition>
            <h1 class="mb-2 font-weight-bold" :class="{'display-2': $vuetify.breakpoint.mdAndDown, 'display-3': $vuetify.breakpoint.lgAndUp}">The Global<br>Economy<br>For Women</h1>
              <div class="subheading mb-3"><strong>SHE</strong> is a digital bartering community that removes the middleman for a true 
                                                      Woman-to-Woman (W2W) economy. <strong>Exchange goods</strong> safely and privately, <strong>mint NFTs</strong> that create residual income, and<strong> get paid to learn</strong> about modern technology 
                                                      like artificial intelligence and the Internet of Things.</div>
                <v-flex class="pl-0 ml-0" xs12 sm9 md6>
                <v-btn
                  class="primary mt-3 ml-0"
                  dark
                  large
                  text
                  @click.prevent="$vuetify.goTo('#secTwo', {duration: 1000, offset: -175, easing: 'easeInQuint'})"
                  to="#"
                >
                  Learn More
                </v-btn>
              </v-flex>
          </v-flex>
          <v-flex justify-center xs12 class="animated slideInRight delay-1s hidden-lg-and-up text-center">
            <v-img contain position="bottom center" :src="require('@/assets/pic-mobile.svg')" height="300" max-height="500"></v-img>
          </v-flex>
          <v-flex xs12 sm8 md6 offset-lg1 class="animated slideInRight delay-1s hidden-md-and-down">
            <v-img v-show="openAnim" contain position="bottom center" :src="firstPic" height="752"></v-img>
            <v-img v-show="!openAnim" contain position="bottom center" :src="secondPic" height="752"></v-img>
          </v-flex>
            
          </v-layout>
        </v-container>
        <v-container id="secTwo" grid-list-xl>
          <v-layout justify-center row wrap>
            <v-flex text-xs-center xs12 sm10 md6 lg6 class="video-wrapper animated fadeInUp delay-1s" :class="{'big-screen': $vuetify.breakpoint.lgAndUp}">
              <v-responsive :aspect-ratio="16/9" class="embed-container" :height="vidHeight" :width="vidWidth">
                <iframe width="560" height="315" src="" data-src="https://www.youtube.com/embed/KmV9TON7ytk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </v-responsive>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center>
            <v-flex text-xs-left text-lg-center xs12 sm10 md6>
              <div class="subheading mb-3">Who’s behind <strong>SHE</strong>? Leading professionals in <strong>blockchain, AI, technology, marketing, and retail</strong>—including many entrepreneurial-spirited women who are committed to the cause. The <strong>SHE</strong> Team is united by a desire to <strong>support and empower women</strong> through economic freedom, incentivized educational opportunities, and a safe space to share the female experience globally.</div>
              <div @mouseover="hovered" @mouseleave="unhovered">
                <v-btn
                  class="font-weight-bold simple-btn"
                  style="position: relative"
                  rounded
                  large
                  text
                  color="primary"
                  :class="{'meet-mobile': $vuetify.breakpoint.mdAndDown, '': $vuetify.breakpoint.lgAndUp}"
                  @click="$vuetify.goTo('#team-sec', {duration: 1200, offset: 0, easing: 'easeInOutCubic'})"
                  >
                  Meet the team <v-icon class="tweenIt" large>arrow_right_alt</v-icon>
                </v-btn>
              </div>
            </v-flex> 
          </v-layout>
        </v-container>

        <v-container
            :class="{'section-mobile': $vuetify.breakpoint.mdAndDown, 'section-full': $vuetify.breakpoint.lgAndUp}" id="nft" fill-height grid-list-xl justify-center>
          <v-layout
            row
            wrap
            justify-center
            align-center
            class="bg-light rounded-xl"
            :class="{'py-0 my-0': $vuetify.breakpoint.mdAndDown, 'my-5': $vuetify.breakpoint.lgAndUp}"
          >
          <v-flex justify-center xs12 class="mt-10 pt-0">
            <v-img contain position="bottom center" :src="require('@/assets/mood.svg')" height="300"></v-img>
          </v-flex>

          <v-flex text-xs-left text-lg-center xs12 sm10 md6 lg4 :class="{'py-0 mb-5': $vuetify.breakpoint.mdAndDown, 'pb-5 mb-5': $vuetify.breakpoint.lgAndUp}">
            <div class="pt-4">
              <h2 class="mid-header mid-primary text-xs-left text-lg-center">The <strong>She NFT</strong> Marketplace</h2>
            <div class="subheading mb-3 py-4 text-xs-left text-lg-center" :class="{'px-0': $vuetify.breakpoint.mdAndDown, 'px-4': $vuetify.breakpoint.lgAndUp}"><strong>NFTs</strong> are so hot right now and <strong>She</strong> plans to put women's NFTs in the forefront of the movement. Starting with our own <strong>MoodNFT</strong> concept that lets users create, mint, collect, and remix interactive mood boards with a portion of the proceeds going towards charities that support women everywhere.</div>
            </div>
              <v-btn  href="https://nft.sheplatform.io" class="primary mt-3" large text dark>Learn More</v-btn>
          </v-flex>
            
          </v-layout>
        </v-container>

        <v-container
            v-intersect="{
              handler: onIntersect,
              options: {
                threshold: [0, 0.5, 1.0]
              }
            }" :class="{'section-mobile': $vuetify.breakpoint.mdAndDown, 'section-full': $vuetify.breakpoint.lgAndUp}" id="woman-to-woman" fill-height grid-list-xl justify-center>
          <v-layout
            row
            wrap
            justify-center
            align-center
            :class="{'py-0 my-0': $vuetify.breakpoint.mdAndDown, 'my-5': $vuetify.breakpoint.lgAndUp}"
          >
          <v-flex justify-center xs12 class="animated mt-0 pt-0 slideInLeft delay-1s hidden-lg-and-up">
            <v-img contain position="bottom center" :src="require('@/assets/pic2-mobile.svg')" height="300"></v-img>
          </v-flex>
          <transition
            name="custom-classes-transition"
            enter-active-class="animated fadeInLeft"
            leave-active-class="animated fadeOutLeft"
            appear
          >
          <v-img v-if="isIntersecting" contain position="top center" class="grabber hidden-md-and-down" :src="require('@/assets/pic2.svg')" height="auto"></v-img>
          </transition>
          <v-flex text-xs-left text-lg-center xs12 sm10 md6 lg4 :class="{'py-0 mb-5': $vuetify.breakpoint.mdAndDown, 'py-5 my-5': $vuetify.breakpoint.lgAndUp}">
            <div class="pt-4" :class="{'': $vuetify.breakpoint.mdAndDown, 'float-box': $vuetify.breakpoint.lgAndUp}">
              <h2 class="mid-header mid-secondary text-xs-left text-lg-center">The <strong>Woman</strong> to <strong>Woman</strong> Economy</h2>
            <div class="subheading sec-subhead mb-3 py-4 text-xs-left text-lg-center" :class="{'px-0': $vuetify.breakpoint.mdAndDown, 'px-4': $vuetify.breakpoint.lgAndUp}"><strong>SHE</strong> establishes value standards for new and used products, offers women advanced tools to appraise the value of items they own or wish to buy, and offers access to a <strong>global marketplace</strong> where items can be bought, sold, traded, rented, or donated via a fun and simple app.</div>
            </div>
              <Platform></Platform>
          </v-flex>
            
          </v-layout>
        </v-container>

        <v-container 
          v-intersect="{
              handler: onIntersect2,
              options: {
                threshold: [0, 0.5, 1.0]
              }
            }" :class="{'section-mobile': $vuetify.breakpoint.mdAndDown, 'section-full': $vuetify.breakpoint.lgAndUp}" id="connect" fill-height grid-list-xl justify-center>
          <v-layout
            row
            wrap
            justify-center
            align-center
          >
          <v-flex xs12 class="animated mt-0 pt-0 slideInRight delay-1s hidden-lg-and-up">
            <v-img contain position="bottom center" :src="require('@/assets/haircut-mobile.svg')" height="300"></v-img>
          </v-flex>
          <transition
            name="custom-classes-transition"
            enter-active-class="animated slideInRight"
            leave-active-class="animated fadeOutRight"
            appear
          >
          <v-img v-if="isIntersecting2" contain position="top center" class="grabber-2 hidden-md-and-down" :src="require('@/assets/haircut-full.svg')" height="auto"></v-img>
          </transition>
            <v-flex justify-center text-xs-left text-lg-center xs12 sm10 md6 lg4 :class="{'py-0, mb-5': $vuetify.breakpoint.mdAndDown, 'py-5, my-5': $vuetify.breakpoint.lgAndUp}">
              <div class="pt-4" :class="{'': $vuetify.breakpoint.mdAndDown, 'float-box': $vuetify.breakpoint.lgAndUp}">
                <h2 class="mid-header mid-primary">Making The <strong>Right</strong> Connections</h2>
              <div class="subheading mb-3 py-4" :class="{'px-0': $vuetify.breakpoint.mdAndDown, 'px-4': $vuetify.breakpoint.lgAndUp}">By connecting advanced IoT devices like mobile-friendly microscopic cameras and our revolutionary <strong>FashionistAI</strong>, clothing and accessories find the closets where they belong while the women who own them find <strong>peace, organization, and extra cash in their wallet</strong> (not to mention a great sense of fashion!).<br/><br/>
              Plus, skilled tradeswomen find work-- even the hair that falls from the beautician’s scissors finds a wig manufacturer. <strong>Everything women do</strong> on <strong>SHE</strong> and within the women’s economy <strong>has value</strong>.
              </div>
              </div>
                <Tech></Tech>
            </v-flex>            
          </v-layout>
        </v-container>

        <v-container
        v-intersect="{
              handler: onIntersect3,
              options: {
                threshold: [0, 0.5, 1.0]
              }
            }" :class="{'section-mobile': $vuetify.breakpoint.mdAndDown}" class="section-full" id="tech" fill-height grid-list-xl justify-center>
          <v-layout
            row
            wrap
            justify-center
            align-center
          >
          <v-flex xs12 class="animated mt-0 pt-0 slideInLeft delay-1s hidden-lg-and-up">
            <v-img contain position="bottom center" :src="require('@/assets/phone-mobile.svg')" height="300" max-height="350"></v-img>
          </v-flex>
          <transition
            name="custom-classes-transition"
            enter-active-class="animated slideInLeft"
            leave-active-class="animated slideOutLeft"
            appear
          >
          <v-img v-if="isIntersecting3" contain position="top left" class="grabber-3 hidden-md-and-down" :src="require('@/assets/phone-full.svg')" height="auto"></v-img>
          </transition>
            <v-flex justify-center text-xs-left text-lg-center xs12 sm10 md6 lg4 :class="{'py-0, mb-5': $vuetify.breakpoint.mdAndDown, 'py-5, my-5': $vuetify.breakpoint.lgAndUp}">
              <div class="mb-1" :class="{'py-0, my-0': $vuetify.breakpoint.mdAndDown, 'pt-5, mt-5': $vuetify.breakpoint.lgAndUp}">
                <h2 class="mid-header mid-secondary mt-3">The <strong>She</strong> Token</h2>
              <div class="subheading sec-subhead mb-2 pt-4"  :class="{'px-0': $vuetify.breakpoint.mdAndDown, 'px-4': $vuetify.breakpoint.lgAndUp}">Our in-app currency exclusive to the <strong>SHE Platform</strong>. Women will receive <strong>SHE Tokens</strong> for every valuable action they take on the platform and through the application.<br/><br/><strong>With <strong>She Tokens</strong> users will be able to:</strong></div>
              <div v-for="benefit in benefits" style="border-radius: 3px" :key="benefit.text" class="mb-2 float-box-dark float-box pt-3 pb-1 px-3" >
                <p class="list-items"><v-icon class="listicons">{{ benefit.icon }}</v-icon> {{ benefit.text }}</p>
              </div>
              </div>
            </v-flex>            
          </v-layout>
        </v-container>

        <v-container grid-list-xl mx-0 px-0 class="team-bg" id="team-sec" :class="{'py-5': $vuetify.breakpoint.mdAndUp}">
          <Team></Team>
        </v-container>
        <v-container grid-list-xs-5 id="join" style="z-index: 1;position: relative">
          <v-layout row wrap :class="{'pt-5 justify-center': $vuetify.breakpoint.mdAndDown}">
            <v-flex xs12 sm10 md6 offset-lg3 lg3>
              <div class="float-box" :class="{'pt-5': $vuetify.breakpoint.mdAndDown}" >
                <h2 class="mid-header mid-primary text-xs-left">The Only Thing Missing Is <strong>You</strong></h2>
                <p class="subheading mb-3 py-4 text-xs-left">
                Here at <strong>SHE</strong> we know that we can't do this without an <strong>amazing group of women</strong> using the platform, buying and selling with <strong>SHE Tokens</strong>, and clicking on the app each day.<br><br>
                Sign up for the newsletter below to stay updated on our development and be the first to know when we launch.<br><br>
                <strong>We look forward to having you on board!</strong>
                </p>
              <v-form ref="forms" v-model="valid" @submit.prevent="trigger" class="submit-form elevation-5">
                <v-text-field
                  name="email"
                  label="Enter your email for updates"
                  id="email"
                  v-model="$store.state.email"
                  class="mb-0 pb-0"
                  required
                  :rules="emailRules"
                ></v-text-field>
                <v-btn 
                  :loading="loading"
                  :disabled="loading"
                  v-if="$store.state.email && valid == true"
                  class="mt-0 pt-0"
                  type="submit"
                  block
                  color="primary"
                >
                Keep Me In The Loop
                </v-btn>
              </v-form>              
              </div>
            </v-flex>
            <v-flex xs12 lg3>
              <v-img :class="{'img-mobile': $vuetify.breakpoint.mdAndDown}" contain position="center right" :src="require('@/assets/join.png')" height="500px"></v-img>              
            </v-flex>
          </v-layout>
        </v-container>
        <v-snackbar
        v-model="snackbar"
        color="error"
        multi-line
        :timeout="timeout"
        top
      >
        {{ error }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      </section>
</template>

<script>
import Team from "../components/Data/Team.vue";
import Platform from "../components/UI/Platform.vue";
import Tech from "../components/UI/Tech.vue";
import firebase from 'firebase/app';
import functions from 'firebase/functions';

function init() {
var vidDefer = document.getElementsByTagName('iframe');
for (var i=0; i < vidDefer.length; i++) {
if(vidDefer[i].getAttribute('data-src')) {
vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
} } }
window.onload = init;

  export default {
    data() {
      return {
        loading: false,
        timeout: 5000,
        snackbar: false,
        error: null,
        target: '#secTwo',
        duration: 300,
        offset: 0,
        offsetTop: 0,
        valid: true,
        isIntersecting: false,
        isIntersecting2: false,
        isIntersecting3: false,
        firstPic: require('@/assets/pic.svg'),
        secondPic: require('@/assets/picreverse.svg'),
        email: null,
        emailRules: [
          (v) => !!v || 'We like you even without your email',
          (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        firstName: '',
        slide: false,
        benefits: [
          { 
            text: 'Mint and Collect Unique She NFTs',
            icon: 'fingerprint'
          },
          { 
            text: 'Exchange tokens with anyone on the app',
            icon: 'compare_arrows'
          },
          {
            text: 'Redeem tokens for products and services',
            icon: 'payment'
          },
          {
            text: 'Gain bulk purchasing power on the network',
            icon: 'add_shopping_cart'
          },
          {
            text: 'Fill value gaps while trading with other users',
            icon: 'widgets'
          },
          {
            text: 'Strengthen the SHE Community with each purchase',
            icon: 'people'
          }
          
        ]
      }
    },
    components: {
      Team,
      Platform,
      Tech
    },
    computed: {
      vidWidth () {
        if (this.$vuetify.breakpoint.mdAndUp) {
          return 640
        } else {
          return null
        }
      },
      vidHeight () {
        if (this.$vuetify.breakpoint.mdAndUp) {
          return 360
        } else {
          return null
        }
      },
      options () {
        return {
          duration: this.duration,
          offset: this.offset,
          easing: this.easing
        }
      },
      openAnim () {
        if (this.offsetTop <= 20) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      onIntersect (entries) {
        this.isIntersecting = entries[0].intersectionRatio >= 0.5
      },
      onIntersect2 (entries) {
        this.isIntersecting2 = entries[0].intersectionRatio >= 0.5
      },
      onIntersect3 (entries) {
        this.isIntersecting3 = entries[0].intersectionRatio >= 0.5
      },
      hovered() {
        this.slide = true
      },
      unhovered() {
        this.slide = false
      },
      trigger () {
        this.loading = true
        let addSubscriber = firebase.functions().httpsCallable('addSubscriber')
        addSubscriber({ email: this.$store.state.email }).then(result => {
          if (result.data == "good") {
            this.loading = false
            this.$router.push({ name: 'thanks' })
          } else {
            this.loading = false
            let errorTxt = result.data.detail,
              substring = "already"
            if (errorTxt.includes(substring)) {
              this.error = "Whoops, looks like you're already subscribed."
              this.snackbar = true
            } else {
              this.error = `Woah! That email looks sketch.`
              this.snackbar = true
            }
            
          }
        })
      },
      onScroll () {
        this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
      }
    }
  }
</script>

<style lang="scss">
$break-xsmall: 600px;
$break-small: 960px;
$break-medium: 1264px;
$break-large: 1904px;

$olc: #2f454c; // on light colors
.img-mobile {
  height: 210px !important;
}
.v-btn__content:hover > .tweenIt {
    transform: translateX(10px);
}
.simple-btn:hover:before {
  background: transparent !important;
}
.tweenIt {
    transition: all .2s !important;
    transform: translateX(0px);
}

h1.mb-2.font-weight-bold.display-3 {
  position: relative;
}

.subheading strong {
    color: #607cda;
}

.meet-mobile {
  padding-left: 0 !important;
  margin-left: 1px;
}

.sec-subhead strong {
    color: #E98A70 !important;
}
.nft-subhead strong {
    color: #32a046 !important;
}
#player {
    border-radius: 6px;
}
.app-image {
    height: 540px !important;
    position: absolute;
    left: 210px;
    top: -25px;
    width: 320px;
    z-index: -1;
}

.team-bg {
  background-image: url(../assets/bg_team.svg);
    background-size: cover;
    margin: 60px 0 40px 0 !important;
    width: 100% !important;
    max-width: 100%;
    @media (max-width: $break-medium) {
      margin: 0 !important;
    }
}
.section-full {
  background-size: contain;
}
#global-economy {
  background-image: url(../assets/bg.svg);  
  background-position: top right;
  margin: -3px 0 40px 0;
  width: 100% !important;
  margin-right: 0 !important;
  max-width: 100%;
}
#woman-to-woman {
  background-image: url(../assets/bg2.svg);
  background-position: top left;
  margin: -3x 0 40px 0;
  width: 100% !important;
  margin-right: 0 !important;
  max-width: 100%;
  position: relative;
}
.layout.bg-light {
    background-color: #f1f1f3;
}
#secTwo {
  width: 100% !important;
  margin-right: 0 !important;
  max-width: 100%;
  position: relative;
}
#connect {
  background-image: url(../assets/bg3.svg);
  background-position: top right;
  margin: -3x 0 40px 0;
  width: 100% !important;
  margin-right: 0 !important;
  max-width: 100%;
  position: relative;
}
#tech {
  background-image: url(../assets/bg4.svg);
  background-position: top left;
  margin: -3x 0 40px 0;
  width: 100% !important;
  margin-right: 0 !important;
  max-width: 100%;
  position: relative;
}
.video-wrapper {
    position: relative;
}

.theme--light.application {
    background: transparent;
}
h2.mid-header.mid-secondary {
    color: #e98a70;
    font-weight: 400;
    font-size: 22px;
}
h2.mid-header.mid-primary {
    color: #607cda;
    font-weight: 400;
    font-size: 22px;
}
.float-box {
    background: #ffffffcf;
    border-radius: 12px;
    &-dark {
      background: #f2f3f4;
    }
}
.video-wrapper.animated.fadeInUp.delay-1s {
    width: 640px;
    max-width: 100%;
    margin: 0 auto;
}
.v-responsive.v-image.grabber {
    height: 610px !important;
    position: absolute;
    left: 1rem;
    top: 30px;
    z-index: 5;
    width: 480px;
}
.v-responsive.v-image.grabber-2 {
    height: 650px !important;
    position: absolute;
    right: 1rem;
    top: 170px;
    z-index: 5;
    width: 500px;
}
.v-responsive.v-image.grabber-3 {
    height: 800px !important;
    position: absolute;
    left: 0px;
    top: -50px;
    z-index: 5;
    width: 600px;
}
p.list-items {
    font-size: 16px;
    font-weight: 400;
    padding-left: 45px;
    position: relative;
}
.listicons {
    position: absolute !important;
    left: 5px;
}
@media (min-width: 480px) {
  .listicons {
    left: 20px;
  }
}
form.v-form.submit-form {
    background: #f2f3f4;
    padding: 5px 20px 10px;
    border-radius: 12px;
}

.bg-circle {
    position: absolute;
    border-radius: 100%;
    background-color: transparent;
    transition: all 2s;
    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    z-index: -1;
    &-0 {
      left: 1rem;
      top: 36rem;
      width: 120px;
      height: 120px;
      border: 17px solid #F1F1F3;
    }
    &-1 {
      left: 7rem;
      top: 30rem;
      width: 60px;
      height: 60px;
      border: 9px solid #F1F1F3;
    }
    &-2 {
      right: 50rem;
      top: 50rem;
      width: 40px;
      height: 40px;
      border: 6px solid #F1F1F3;
    }
    &-3 {
      left: 8rem;
      top: 82rem;
      width: 50px;
      height: 50px;
      border: 6px solid #F1F1F3;
    }
    &-4 {
      top: 97rem;
      right: 21.5rem;
      width: 30px;
      height: 30px;
      border: 6px solid #F1F1F3;
    }
    &-5 {
      top: 180rem;
      left: 5rem;
      width: 30px;
      height: 30px;
      border: 6px solid #F1F1F3;
    }
    &-6 {
      top: 220rem;
      left: 50rem;
      width: 80px;
      height: 80px;
      border: 10px solid #F1F1F3;
    }
    &-7 {
      top: 260rem;
      right: 50rem;
      width: 30px;
      height: 30px;
      border: 5px solid #F1F1F3;
    }
    &-8 {
      top: 300rem;
      left: 50rem;
      width: 20px;
      height: 20px;
      border: 5px solid #F1F1F3;
    }
    &-9 {
      top: 400rem;
      left: 50rem;
      width: 80px;
      height: 80px;
      border: 10px solid #F1F1F3;
    }
}
div#myElement {
    border-radius: 7px;
    box-shadow: 0 0 14px #19191963;
}
.jw-icon-rewind {
    display: none;
}
.jw-settings-sharing {
    display: none;
}
.jw-icon-settings.jw-settings-submenu-button {
    display: none;
}
.jw-icon.jw-icon-inline.jw-button-color.jw-reset.jw-logo-button {
    height: 64px;
    width: 64px;
    position: absolute;
    left: 50%;
    top: 0;
}
.jw-controlbar .jw-button-image {
    background: no-repeat 50% 50%;
    background-size: contain;
    max-height: 64px;
}
.jw-state-idle .jw-controls, .jw-controls-backdrop {
  background: rgba(255, 255, 255, 0) !important;
}
.jw-icon {
    height: 74px;
    width: 74px;
    background-color: transparent;
}
.she {
  position: absolute;
  transition: all 2s;
  -webkit-transition: all 2s;

  font-family: 'Baloo', sans-serif;
  font-size: 200px;
  color: #f1f1f3;
  z-index: -1;
  &-logo {
    top: -3rem;
    left: 0rem;    
  }
  &-build {
    top: 80rem;
    right: 0rem;
  }
  &-find {
    top: 100rem;
    left: 0rem;
  }
  &-earn {
    top: 140rem;
    right: 0rem;
  }
  &-play {
    top: 230rem;
    left: 0rem;
  }
  &-join {
    top: 350rem;
    right: 0rem;
  }
}
.section-mobile {
  background: none !important;
}
.big-screen:before {
    content: "";
    height: 360px;
    width: 640px;
    background: #f1f1f3;
    position: absolute;
    top: -30px;
    left: 20%;
    border-radius: 6px;
    z-index: -1;
}
.embed-container { 
  position: relative;
  overflow: hidden;
  margin: 0 auto
} 
.embed-container iframe, .embed-container object, .embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 360px;

}
</style>

